// extracted by mini-css-extract-plugin
module.exports = {"AnimationA":"AnimationA_AnimationA__IARfv"};